export const destinations = [
  {
    title: "Paris",
    content: "Car rentals in 86 pickup locations",
    category: "black",
    categoryText: "from $540 per day",
    src: "/images/content/city-pic-1.jpg",
    srcSet: "/images/content/city-pic-1@2x.jpg",
    url: "/cars-category",
  },
  {
    title: "London",
    content: "Car rentals in 16 pickup locations",
    category: "black",
    categoryText: "from $111 per day",
    src: "/images/content/city-pic-2.jpg",
    srcSet: "/images/content/city-pic-2@2x.jpg",
    url: "/cars-category",
  },
  {
    title: "Amsterdam",
    content: "Car rentals in 126 pickup locations",
    category: "black",
    categoryText: "from $240 per day",
    src: "/images/content/city-pic-3.jpg",
    srcSet: "/images/content/city-pic-3@2x.jpg",
    url: "/cars-category",
  },
  {
    title: "Milan",
    content: "Car rentals in 6 pickup locations",
    category: "black",
    categoryText: "from $234 per day",
    src: "/images/content/city-pic-4.jpg",
    srcSet: "/images/content/city-pic-4@2x.jpg",
    url: "/cars-category",
  },
  {
    title: "Paris",
    content: "Car rentals in 86 pickup locations",
    category: "black",
    categoryText: "from $540 per day",
    src: "/images/content/city-pic-1.jpg",
    srcSet: "/images/content/city-pic-1@2x.jpg",
    url: "/cars-category",
  },
  {
    title: "London",
    content: "Car rentals in 16 pickup locations",
    category: "black",
    categoryText: "from $111 per day",
    src: "/images/content/city-pic-2.jpg",
    srcSet: "/images/content/city-pic-2@2x.jpg",
    url: "/cars-category",
  },
  {
    title: "Amsterdam",
    content: "Car rentals in 126 pickup locations",
    category: "black",
    categoryText: "from $240 per day",
    src: "/images/content/city-pic-3.jpg",
    srcSet: "/images/content/city-pic-3@2x.jpg",
    url: "/cars-category",
  },
  {
    title: "Milan",
    content: "Car rentals in 6 pickup locations",
    category: "black",
    categoryText: "from $234 per day",
    src: "/images/content/city-pic-4.jpg",
    srcSet: "/images/content/city-pic-4@2x.jpg",
    url: "/cars-category",
  },
  {
    title: "Paris",
    content: "Car rentals in 86 pickup locations",
    category: "black",
    categoryText: "from $540 per day",
    src: "/images/content/city-pic-1.jpg",
    srcSet: "/images/content/city-pic-1@2x.jpg",
    url: "/cars-category",
  },
];
